import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  // If a direct icon component is passed, use it
  if (icon) {
    return React.createElement(icon, props);
  }

  // If a name is passed, try to find it in FiIcons
  if (name) {
    const iconKey = name.startsWith('Fi') ? name : `Fi${name}`;
    const IconComponent = FiIcons[iconKey];
    
    if (IconComponent) {
      return React.createElement(IconComponent, props);
    }
  }

  // Fallback to alert icon if nothing found
  return <FiAlertTriangle {...props} />;
};

export default SafeIcon;